import { useEffect, useState } from "react";
import axios from "axios";
import { config } from "../../data/config";
import { getCookies } from "cookies-next";
import SaleChart from "./SaleChart";
import ChartITem from "./SaleChart";
export default function DashboardInfo() {
    let cookie = getCookies();

    const [data, setData] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const load = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${config.url}/v1/dashboard/dashboardinfo`, {
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setData(response.data);
        } catch (e) {
            console.error('Error loading dashboard info', e);
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        load();
    }, []);
    if (loading && !data) {
        return (
            <div className="p-5">
                <div className="bg-white rounded-xl shadow-sm p-6 flex items-center justify-center">
                    <div className="flex items-center gap-3 text-gray-500">
                        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
                        <span>در حال بارگذاری آمار فروش...</span>
                    </div>
                </div>
            </div>
        );
    }

    if (!data) {
        return null;
    }

    const { stats } = data;

    return (
        <div className="p-5 space-y-6">
            {/* Summary cards row */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4" dir="rtl">
                <div className="bg-gradient-to-br from-blue-600 to-indigo-600 text-white rounded-xl p-4 shadow-sm">
                    <div className="flex items-center justify-between mb-2">
                        <h2 className="text-sm font-semibold">فروش امروز</h2>
                        <span className="text-[11px] bg-white/10 px-2 py-0.5 rounded-full">24 ساعت اخیر</span>
                    </div>
                    <p className="text-xs opacity-80 mb-1">تعداد فروش</p>
                    <p className="text-lg font-bold mb-2">{stats.last24h.count}</p>
                    <p className="text-xs opacity-80 mb-1">مقدار فروش</p>
                    <p className="text-base font-semibold">{stats.last24h.total.toLocaleString('fa-IR')} تومان</p>
                </div>

                <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
                    <h2 className="text-sm font-semibold text-gray-800 mb-1">فروش دیروز</h2>
                    <p className="text-xs text-gray-500 mb-1">تعداد فروش</p>
                    <p className="text-lg font-bold text-gray-800 mb-2">{stats.yesterday.count}</p>
                    <p className="text-xs text-gray-500 mb-1">مقدار فروش</p>
                    <p className="text-base font-semibold text-gray-800">{stats.yesterday.total.toLocaleString('fa-IR')} تومان</p>
                </div>

                <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
                    <h2 className="text-sm font-semibold text-gray-800 mb-1">فروش هفته اخیر</h2>
                    <p className="text-xs text-gray-500 mb-1">تعداد فروش</p>
                    <p className="text-lg font-bold text-gray-800 mb-2">{stats.last7Days.count}</p>
                    <p className="text-xs text-gray-500 mb-1">مقدار فروش</p>
                    <p className="text-base font-semibold text-gray-800">{stats.last7Days.total.toLocaleString('fa-IR')} تومان</p>
                </div>

                <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
                    <h2 className="text-sm font-semibold text-gray-800 mb-1">فروش ماه اخیر</h2>
                    <p className="text-xs text-gray-500 mb-1">تعداد فروش</p>
                    <p className="text-lg font-bold text-gray-800 mb-2">{stats.lastMonth.count}</p>
                    <p className="text-xs text-gray-500 mb-1">مقدار فروش</p>
                    <p className="text-base font-semibold text-gray-800">{stats.lastMonth.total.toLocaleString('fa-IR')} تومان</p>
                </div>
            </div>

            {/* Chart + all-time */}
            <div className="grid grid-cols-1 lg:grid-cols-[2fr,1fr] gap-4" dir="rtl">
                <div className="bg-white rounded-xl shadow-sm p-4">
                    <h3 className="text-sm font-semibold text-gray-800 mb-3">روند فروش روزانه</h3>
                    <ChartITem newData={stats.dailyTrend} />
                </div>

                <div className="bg-white rounded-xl shadow-sm p-4 flex flex-col justify-between">
                    <div>
                        <h3 className="text-sm font-semibold text-gray-800 mb-3">فروش کلی</h3>
                        <p className="text-xs text-gray-500 mb-1">تعداد کل فروش</p>
                        <p className="text-xl font-bold text-gray-900 mb-3">{stats.allTime.count}</p>
                        <p className="text-xs text-gray-500 mb-1">مقدار کل فروش</p>
                        <p className="text-lg font-semibold text-gray-900">{stats.allTime.total.toLocaleString('fa-IR')} تومان</p>
                    </div>
                </div>
            </div>
        </div>
    )
}   